export default __webpack_public_path__ + "static/media/dentist_magda.acf498ec.jpg";